import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { types } from 'helpers';
import { TrxTypes } from 'helpers/types';
import { utilsApi } from '../api/utils.api';

interface Loading {
    primary: string;
    spinning: boolean;
    secondary: string;
}

interface UtilsState {
    env: string;
    limit: number;
    config: {
        fees: any;
        banks: {
            GHS: Bank[];
            NGN: Bank[];
        };
    };
    loading: Loading;
    meCache: string;
    addBusiness: boolean;
    businessCache: string;
    configuration: {
        fees: any;
        limits: any;
        providers: any;
        virtual_banks: Record<any, types.TrxProviders[]>;
        channels_by_currency: Record<string, types.TrxChannels[]>;
        providers_allocation: any;
    };
    isMobileMenuVisible: boolean;
}

interface Bank {
    code: string;
    name: string;
    channel: string;
    types: TrxTypes[];
}

interface UtilsSetUtils {
    key: keyof UtilsState;
    value: any;
}

const initialState: UtilsState = {
    env: 'test',
    limit: 8,
    config: {
        fees: {},
        banks: {
            GHS: [],
            NGN: [],
        },
    },
    loading: {
        primary: '',
        spinning: false,
        secondary: '',
    },
    meCache: Date.now().toString(),
    addBusiness: false,
    businessCache: '',
    configuration: {
        fees: {},
        limits: {},
        providers: {},
        virtual_banks: {},
        channels_by_currency: {},
        providers_allocation: {},
    },
    isMobileMenuVisible: false,
};

export const utilsSlice = createSlice({
    name: '_utils',
    initialState,
    reducers: {
        _setUtils: (state, action: PayloadAction<UtilsSetUtils>) => {
            const { key, value } = action.payload;
            if (key === 'env' || key === 'meCache' || key === 'businessCache') {
                state[key] = value;
            } else if (key === 'limit') {
                state[key] = +value;
            } else if (key === 'loading') {
                if (!value.spinning) {
                    value['primary'] = '';
                    value['secondary'] = '';
                }
                state[key] = { ...state[key], ...value, };
            } else if (key === 'addBusiness' || key === 'isMobileMenuVisible') {
                state[key] = value;
            }
        },
    },
    extraReducers: (builder) => {
        builder.addMatcher(
            utilsApi.endpoints.config.matchFulfilled, (state, action) => {
                state.config = action.payload;
            }
        );

        builder.addMatcher(
            utilsApi.endpoints.configuration.matchFulfilled, (state, action) => {
                state.configuration = action.payload;
            }
        );
    }
});

export const { _setUtils } = utilsSlice.actions;

export default utilsSlice.reducer;